var render = function render(){var _vm=this,_c=_vm._self._c;return _c('xlsx-workbook',[_vm._l((_vm.worksheets),function(sheet){return _c('xlsx-sheet',{key:sheet.name,attrs:{"collection":sheet.data,"sheet-name":sheet.name}})}),_c('xlsx-download',{attrs:{"filename":`${_vm.exportName}.xlsx`}},[_c('button',[_vm._v(" "+_vm._s(_vm.item.text)+" ")])])],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }